// extracted by mini-css-extract-plugin
export default {"TasksLists":"TasksList_TasksLists__Gxm5W","InterventionTasks":"TasksList_InterventionTasks__2CT-E","Overlaps":"TasksList_Overlaps__sV87U"};